export default {
  beCool: {
    id: '404_page_be_cool',
    defaultMessage: 'Stay cool, everything’s going to be ok.',
  },
  cta: {
    id: 'error_page_cta',
    defaultMessage: 'Click here to shop',
  },
  title: {
    id: '404_page_title',
    defaultMessage: '"Gottferdam"',
  },
}
